import React, { useRef } from 'react';
import ReactPlayer from 'react-player';
import PropTypes from 'prop-types';
import { browserTrack } from 'utils/segment';

import './WistiaVideo.scss';

// Our 3 videos:
// https://hometap.wistia.com/medias/xxbvs27hmp
// https://hometap.wistia.com/medias/frmkvy5r7h
// https://hometap.wistia.com/medias/s9lv749fwx

const WistiaVideo = ({ videoId, onReady }) => {
  const videoPlayer = useRef();
  const trackVideo = (event) => {
    return () => {
      const player = videoPlayer.current.getInternalPlayer();
      browserTrack(event, {
        duration: videoPlayer.current.getCurrentTime(),
        id: videoId,
        name: player?.data?.media?.name,
      });
    };
  };

  return (
    <div className="WistiaVideo">
      <ReactPlayer
        className="WistiaVideoReactPlayer"
        url={`https://hometap.wistia.com/medias/${videoId}`}
        ref={videoPlayer}
        controls
        width="100%"
        height="100%"
        onReady={onReady}
        onPlay={trackVideo('Video Played')}
        onPause={trackVideo('Video Paused')}
        onEnded={trackVideo('Video Finished')}
      />
    </div>
  );
};

WistiaVideo.propTypes = {
  videoId: PropTypes.node.isRequired,
};

export default WistiaVideo;
